import {BrowserRouter, Navigate, Routes, Route} from 'react-router-dom';

import { MainLayout, NonAuthLayout } from 'src/layouts';
import { Introduction, Home, DIHome,School, Landing } from 'src/containers';
import { useAuth } from 'src/contexts';
import { FormPage } from './containers/school/FormPage';
import { OperationFormPage } from './containers/school/OperationsFormPage';
import { SearchPage } from './containers/school/SearchPage';
import {ProfilePage} from './containers/school/ProfilePage';
import {DiProfilePage} from './containers/school/DiProfilePage';
import {ProfileEditPage} from './containers/school/ProfileEditPage';
import {DiProfileEditPage} from './containers/school/DiProfileEditPage';
import {APP_URLS} from 'src/constants';
import { DIFormPage } from './di/DIFormPage';

const AppRoutes = () => {
    const {isLoggedIn, isAdmin} = useAuth();

  const AuthedRoutes = (
    <Route path="/" element={<MainLayout isAdmin={isAdmin} />}>
      <Route path="/" element={<Navigate to={APP_URLS.LANDING} replace/>}/>
      <Route path="*" element={<Navigate to={APP_URLS.LANDING} replace />}/>
      <Route path="landing" element={<Landing/>}/>
      <Route path="home" element={<Home />} />
      <Route path="dihome" element={<DIHome />} />
      <Route path="school" element={<School />} />
      <Route path="form" element={<FormPage />} />
      <Route path="diform" element={<DIFormPage />} />
      <Route path="operation-form" element={<OperationFormPage />} />
      <Route path="search" element={<SearchPage />} />
      <Route path="profile" element={<ProfilePage/>}/>
      <Route path="profile-edit-form" element={<ProfileEditPage/>}/>
      <Route path="diprofile" element={<DiProfilePage/>}/>
      <Route path="diprofile-edit" element={<DiProfileEditPage/>}/>
    </Route>
  );

  const NonAuthedRoutes = (
    <Route path="/" element={<NonAuthLayout />}>
      <Route path="/" element={<Introduction />} />
      <Route path="/*" element={<Introduction />} />
    </Route>
  );

  return (
    <BrowserRouter>
      <Routes>{isLoggedIn ? AuthedRoutes : NonAuthedRoutes}</Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
